import { UI_OPTION_KEYS } from './uiOptionKeys';
import { LISTING_STATUSES, OWNERSHIP_BASES, OWNERSHIP_STRUCTURES } from '../ownershipCriteria';

const toLabelMap = (options) => Object.fromEntries(options.map(({ name, value }) => [name, value]));

export const UI_OPTIONS = {
  [UI_OPTION_KEYS.SEARCH_TYPE]: {
    Funds: 'funds',
    'Portfolio Co.': 'portfolios',
    .../*['dev', 'stg']*/ ([].includes(import.meta.env.VITE_ENVIRONMENT)
      ? { Corporates: 'investprofiles' }
      : {}),
    Profiler: 'profiler',
    Individuals: 'individuals'
  },
  [UI_OPTION_KEYS.FUND_SEARCH_CATEGORY]: {
    'Investment criteria': 'investmentCriteria',
    'Private equity fund name': 'privateEquityFundName',
    'Fund name': 'fundName'
  },
  [UI_OPTION_KEYS.PORTFOLIO_SEARCH_CATEGORY]: {
    'Investment criteria': 'investmentCriteria',
    'Portfolio company name': 'portfolioCompanyName'
  },
  [UI_OPTION_KEYS.PROFILER_SEARCH_CATEGORY]: {
    Characteristics: 'companyCriteria',
    Industries: 'industryCodes',
    Name: 'companyName',
    Bulk: 'companyBulkSearch'
  },
  [UI_OPTION_KEYS.INDIVIDUALS_SEARCH_CATEGORY]: {
    Name: 'individualsName'
  },
  [UI_OPTION_KEYS.CONTACT_FILTER_IS_SHAREHOLDER]: {
    Yes: 'Yes'
    // No: 'No'
  },
  [UI_OPTION_KEYS.CONTACT_FILTER_AGE]: {
    '<30': '<30',
    '30 - 39': '30 - 39',
    '40 - 49': '40 - 49',
    '50 - 59': '50 - 59',
    '60+': '60+'
  },
  [UI_OPTION_KEYS.PROFILER_HEATMAP_SIZE]: {
    Sales: '_heatmapRevenue',
    EBIT: '_heatmapEbit'
  },
  [UI_OPTION_KEYS.PROFILER_HEATMAP_COLOR_CODING]: {
    'EBIT Margin (%)': '_heatmapEbitMargin',
    'CAGR 3Y (%)': '_heatmapCagr3Y',
    'CAGR 4Y (%)': '_heatmapCagr4Y'
  },
  // Front-end owned until the backend serves them; a nomenclature key of the same name
  // would override these in UtilsStore.loadOptions.
  [UI_OPTION_KEYS.PROFILER_LISTING_STATUS]: toLabelMap(LISTING_STATUSES),
  [UI_OPTION_KEYS.PROFILER_OWNERSHIP_STRUCTURE]: toLabelMap(OWNERSHIP_STRUCTURES),
  [UI_OPTION_KEYS.PROFILER_OWNERSHIP_BASIS]: toLabelMap(OWNERSHIP_BASES)
};

export const UI_OPTIONS_UTILS = Object.fromEntries(
  Object.entries(UI_OPTIONS).map(([key, values]) => [
    key,
    Object.entries(values).map(([name, value]) => ({ name, value }))
  ])
);
